function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 6.25C8.27614 6.25 8.5 6.47386 8.5 6.75L8.50001 13.5C8.50001 13.7761 8.27615 14 8.00001 14C7.72387 14 7.50001 13.7761 7.50001 13.5L7.5 6.75C7.5 6.47386 7.72386 6.25 8 6.25Z",
  fill: "#42526E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.00001 2C8.27615 2 8.50001 2.22386 8.50001 2.5L8.5 4.25C8.5 4.52614 8.27614 4.75 8 4.75C7.72386 4.75 7.5 4.52614 7.5 4.25L7.50001 2.5C7.50001 2.22386 7.72387 2 8.00001 2Z",
  fill: "#42526E"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 4.75C7.58579 4.75 7.25 5.08579 7.25 5.5C7.25 5.91421 7.58579 6.25 8 6.25C8.41421 6.25 8.75 5.91421 8.75 5.5C8.75 5.08579 8.41421 4.75 8 4.75ZM6.25 5.5C6.25 4.5335 7.0335 3.75 8 3.75C8.9665 3.75 9.75 4.5335 9.75 5.5C9.75 6.4665 8.9665 7.25 8 7.25C7.0335 7.25 6.25 6.4665 6.25 5.5Z",
  fill: "#42526E"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5 11.25C12.7761 11.25 13 11.4738 13 11.75L13.0001 13.5C13.0001 13.7761 12.7762 14 12.5001 14C12.2239 14 12.0001 13.7762 12.0001 13.5L12 11.75C12 11.4739 12.2238 11.25 12.5 11.25Z",
  fill: "#42526E"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5001 2C12.7762 2 13.0001 2.22386 13.0001 2.5L13 9.25C13 9.52615 12.7761 9.75 12.5 9.75C12.2239 9.75 12 9.52614 12 9.25L12.0001 2.5C12.0001 2.22385 12.2239 2 12.5001 2Z",
  fill: "#42526E"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5 9.75C12.0858 9.75 11.75 10.0858 11.75 10.5C11.75 10.9142 12.0858 11.25 12.5 11.25C12.9142 11.25 13.25 10.9142 13.25 10.5C13.25 10.0858 12.9142 9.75 12.5 9.75ZM10.75 10.5C10.75 9.5335 11.5335 8.75 12.5 8.75C13.4665 8.75 14.25 9.5335 14.25 10.5C14.25 11.4665 13.4665 12.25 12.5 12.25C11.5335 12.25 10.75 11.4665 10.75 10.5Z",
  fill: "#42526E"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.50004 9.25C3.77618 9.25 4.00004 9.47386 4.00004 9.75L4 13.5C4 13.7761 3.77614 14 3.49999 14C3.22385 14 3 13.7761 3 13.5L3.00004 9.75C3.00004 9.47385 3.2239 9.25 3.50004 9.25Z",
  fill: "#42526E"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.5 2C3.77614 2 4 2.22385 4 2.5L4.00004 7.25C4.00004 7.52614 3.77618 7.75 3.50004 7.75C3.2239 7.75 3.00004 7.52615 3.00004 7.25L3 2.5C3 2.22386 3.22385 2 3.5 2Z",
  fill: "#42526E"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.5 7.75C3.08579 7.75 2.75 8.08579 2.75 8.5C2.75 8.91421 3.08579 9.25 3.5 9.25C3.91421 9.25 4.25 8.91421 4.25 8.5C4.25 8.08579 3.91421 7.75 3.5 7.75ZM1.75 8.5C1.75 7.5335 2.5335 6.75 3.5 6.75C4.4665 6.75 5.25 7.5335 5.25 8.5C5.25 9.4665 4.4665 10.25 3.5 10.25C2.5335 10.25 1.75 9.4665 1.75 8.5Z",
  fill: "#42526E"
});

function SvgSliders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliders);
export default __webpack_public_path__ + "static/media/Sliders.21673eb6.svg";
export { ForwardRef as ReactComponent };